import type { PropsWithChildren } from 'react';
import type React from 'react';

import { StarterDashboardBannerStateContextProvider } from './context';
import { useBannerState } from './hook';

export const StarterDashboardBannerStateProvider: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	const bannerState = useBannerState();

	return (
		<StarterDashboardBannerStateContextProvider {...bannerState}>{children}</StarterDashboardBannerStateContextProvider>
	);
};
